import { render, staticRenderFns } from "./SubSampleCard.vue?vue&type=template&id=7b8a31b9&scoped=true&"
import script from "./SubSampleCard.vue?vue&type=script&lang=js&"
export * from "./SubSampleCard.vue?vue&type=script&lang=js&"
import style0 from "./SubSampleCard.vue?vue&type=style&index=0&id=7b8a31b9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b8a31b9",
  null
  
)

export default component.exports